import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { SubscriptionFormProps } from '.';
import { STRIPE_PUBLISH_KEY } from '../../src/env';
import { createSetupIntent, createSubscription } from '../../utils/backend-api/stripe';
import { Spinner } from '../BaseUI';
import PaymentMethod from './PaymentMethod';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);
const PaymentForm = ({
  buttonText,
  currentTrialEndDate,
  isUserCBPT,
  referringSubscriberName,
  referringSubscriberGuid,
  selectedOffer,
  stripeCustomerId,
  userNextBillingDate,
}: SubscriptionFormProps) => {
  const [clientSecret, setClientSecret] = useState('');
  const [subscriptionId, setSubscriptionId] = useState('');
  const isTrial = !!referringSubscriberName;

  useEffect(() => {
    (async () => {
      try {
        // With a trial, we don't bill the user right away, so we need to create a setup intent to collect a payment method to use later
        // Without a trial, we can create the subscription right away, which creates a payment intent to collect payment and bill the user
        if (isTrial) {
          const { clientSecret } = await createSetupIntent({
            stripe_customer_id: stripeCustomerId,
          });
          setClientSecret(clientSecret);
        } else {
          const { clientSecret, subscriptionId } = await createSubscription({
            code: selectedOffer.code,
            stripe_customer_id: stripeCustomerId,
          });
          setClientSecret(clientSecret);
          setSubscriptionId(subscriptionId);
        }
      } catch {
        toast.error('Something went wrong. Please refresh this page or try again later.');
      }
    })();
  }, [isTrial, stripeCustomerId, selectedOffer.code]);

  return (
    <>
      {clientSecret ? (
        <Elements key={clientSecret} stripe={stripePromise} options={{ clientSecret }}>
          <PaymentMethod
            buttonText={buttonText}
            currentTrialEndDate={currentTrialEndDate}
            isTrial={isTrial}
            isUserCBPT={isUserCBPT}
            referringSubscriberName={referringSubscriberName}
            referringSubscriberGuid={referringSubscriberGuid}
            selectedOffer={selectedOffer}
            subscriptionId={subscriptionId}
            userNextBillingDate={userNextBillingDate}
          />
        </Elements>
      ) : (
        <div className="tw-text-center tw-my-16">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default PaymentForm;
